import React from 'react'
import { Grid, Typography, Button } from '@mui/material'
import PidoImage from '../../assets/images/pido.png'
import useStyles from './styles'

function NotFound() {
    const classes = useStyles()

    return (
        <React.Fragment>
            <Grid className={classes.gridImage}>
                <img
                    src={PidoImage}
                    alt={"pido"}
                    className={classes.image} />
            </Grid>
            <Grid className={classes.content}>
                <br />
                <Typography fontSize={40}>
                    {"خطای 404"}
                </Typography>
                <br />
                <Typography fontSize={20} fontWeight={450}>
                    {"صفحه مورد نظر یافت نشد"}
                </Typography>
                <br />
                <Button
                    href='https://pido.co.ir'
                    variant='contained'
                >
                    {"بازگشت به سایت"}
                </Button>
                <br />
                <Button
                    variant="outlined"
                    href='tel:02191076222'
                    color="secondary"
                >
                    {"تماس با پشتیبانی"}
                </Button>
            </Grid>
        </React.Fragment >
    )
}

export default NotFound
